let Inits=[
  {
    rightnavs: '元素',  
    id: 'gta_ai_event_item',
    title: '',
    content:'。',
    blockText: `<block type="gta_ai_event_item"></block>`,
  }
]
// 事件
let Events = [
  {
    rightnavs: '事件',
    id: 'gta_ai_event_1',
    title: '开始进入Python的世界',
    content:
      '这块积木代表“程序的开端”，并没有实际作用，在Python程序中，它仅仅是一句注释，不会被运行。',
    blockText: `<block type="gta_ai_event_1"></block>`,
  },
  {
    id: 'gta_ai_event_2',
    title: '打印',
    blockText: `<block type="gta_ai_event_2"></block>`,
    content: '可用来打印文本、变量、布尔值、列表等内容显示在终端区。',
  },
  {
    id: 'gta_ai_event_print',
    title: '可嵌套积木的打印',
    blockText: `<block type="gta_ai_event_print">
          <value name="NAME">
            <shadow type="gta_ai_event_item"> </shadow>
          </value>
        </block>`,
    content: '第二个打印积木，可打印嵌套内的积木脚本',
  },
  {
    id: 'gta_ai_event_3',
    title: '注释',
    blockText: `<block type="gta_ai_event_3"></block>`,
    content:
      '注释的代码不会被执行，以#为开头注释在单行中，注释主要为提醒作用，也方便他人轻松解读代码的意思，增加可读性。',
  },
  {
    id: 'gta_ai_event_4',
    title: '执行代码（嵌套）',
    blockText: `<block type="gta_ai_event_4"></block>`,
    content:
      '该积木没有实际的用途。Python是一门非常强大的语言，不能将所有的函数转换成我们使用的积木，当你需要用到这些语句时，可以直接在积木里面编写你需要的函数，计算机即可直接运行您写的所有代码。积木的使用方式需要嵌套在其他积木内生效。',
  },
  {
    id: 'gta_ai_event_5',
    title: '执行代码（不可嵌套）',
    blockText: `<block type="gta_ai_event_5"></block>`,
    content:
      '该积木没有实际的用途。Python是一门非常强大的语言，不能将所有的函数转换成我们使用的积木，当你需要用到这些语句时，可以直接在积木里面编写你需要的函数，计算机即可直接运行您写的所有代码。',
  },
  {
    id: 'gta_ai_event_6',
    title: '显示',
    blockText: `<block type="gta_ai_event_6">
          <value name="NAME">
            <shadow type="gta_ai_event_item"></shadow>
          </value>
        </block>`,
    content: '可用来显示变量、摄像头画面等内容。',
  },
  {
    id: 'gta_ai_event_7',
    title: '显示文本',
    blockText: `<block type="gta_ai_event_7">
          <value name="NAME_2">
            <shadow type="gta_ai_event_item"></shadow>
          </value>
        </block>`,
    content: '可用来显示文本内容。',
  },
  {
    id: 'gta_ai_event_8',
    title: '显示媒体图像并注释',
    blockText: `<block type="gta_ai_event_8"></block>`,
    content: '可用来显示媒体摄像头拍摄的画面、图片内容，并加以注释。',
  },
  {
    id: 'gta_ai_event_9',
    title: '设置显示大小',
    blockText: `<block type="gta_ai_event_9">
          <value name="imageSrc">
            <shadow type="gta_ai_event_item"></shadow>
          </value>
          <value name="imageSize">
            <shadow type="math_number">
              <field name="NUM">0</field>
            </shadow>
          </value>
        </block>`,
    content: '可设置文本、图片、视频等对象在运行区域的大小。',
  },
  {
    id: 'gta_ai_event_10',
    title: '运行区划分为_',
    blockText: `<block type="gta_ai_event_10"></block>`,
    content:
      '将显示的绘图区划分为四个宫格来显示不一样的内容，支持将划分区分为1、4、9等分的宫格。',
  },
  {
    id: 'gta_ai_event_11',
    title: '在分区_运行结果',
    blockText: `<block type="gta_ai_event_11"></block>`,
    content:
      '选择好哪个分区来显示对应运行结果的内容，分区的数字可根据实际情况进行修改。',
  },
  {
    id: 'gta_ai_event_12',
    title: '分区_标题为',
    blockText: `<block type="gta_ai_event_12"></block>`,
    content: '对选择好的分区命名，分区的数字可根据实际情况进行修改。',
  },
]

// 控制
let Control = [
  {
    rightnavs: '控制',
    id: 'controls_repeat_ext',
    title: '重复执行（）次',
    content:
      '重复执行是一个嵌套的积木，积木中间可以嵌套其他积木，嵌套的积木部分就是循环的内容。\n积木上面的数字为重复执行的次数，执行完毕后，再执行积木下方的脚本。',
    blockText: `<block type="controls_repeat_ext">
    <value name="TIMES">
      <shadow type="math_number">
        <field name="NUM">20</field>
      </shadow>
    </value>
  </block>`,
  },
  {
    id: 'gta_controls_whileUntil',
    title: '如果…重复执行',
    blockText: `<block type="gta_controls_whileUntil">
    <value name="NAME1">
      <shadow type="logic_null"></shadow>
    </value>
  </block>`,
    content: '如果满足条件，则重复执行嵌套中的代码，如果不满足条件，则不执行。',
  },
  {
    id: 'controls_for',
    title: '变量“i”从_数到_每次增加_',
    blockText: `<block type="controls_for">
    <value name="FROM">
      <shadow type="math_number">
        <field name="NUM">1</field>
      </shadow>
    </value>
    <value name="TO">
      <shadow type="math_number">
        <field name="NUM">10</field>
      </shadow>
    </value>
    <value name="BY">
      <shadow type="math_number">
        <field name="NUM">1</field>
      </shadow>
    </value>
  </block>`,
    content:
      '用变量”i”记录从开始数值到终止数值之间的数值，数值按指定间隔增加，并执行指定的块。',
  },
  {
    id: 'controls_forEach',
    title: '为列表_里的每一项_执行',
    blockText: `<block type="controls_forEach">
    <value name="LIST">
      <block type="variables_get">
        <field name="VAR">列表</field>
      </block>
    </value>
  </block>`,
    content: '遍历列表中的每一项，将变量“i”设为所选项，并执行一些语句。',
  },
  {
    id: 'break_continue',
    title: '跳出循环',
    blockText: `<block type="break_continue"></block>`,
    content: '跳出包含它的循环；需要注意的是这个块只能在循环内使用。',
  },
  {
    id: 'controls_if',
    title: '如果…那么',
    blockText: `<block type="controls_if">
    <value name="IF0">
      <shadow type="logic_null"></shadow>
    </value>
  </block>`,
    content: '如果满足条件，则执行嵌套中的代码，如果不满足条件，则不执行。',
  },
  {
    id: 'logic_negate',
    title: '非…',
    blockText: `<block type="logic_negate">
    <value name="BOOL">
      <shadow type="logic_null">
        <field></field>
      </shadow>
    </value>
  </block>`,
    content: '如果输入结果为假，则返回真；如果输入结果为真，则返回假。',
  },
  {
    id: 'logic_ternary',
    title: '断言__如果为真，__如果为假__',
    blockText: `<block type="logic_ternary">
    <value name="IF">
      <shadow type="logic_null"></shadow>
    </value>
    <value name="THEN">
      <shadow type="gta_ai_controls_item"></shadow>
    </value>
    <value name="ELSE">
      <shadow type="gta_ai_controls_item"></shadow>
    </value>
  </block>`,
    content:
      '检查“断言”里的条件语句。如果条件为真，则返回“如果为真”的值，否则，则返回“如果为假”的值。',
  },
  {
    id: 'waiting_time',
    title: ' 等待（）秒',
    blockText: `<block type="waiting_time"></block>`,
    content:
      '执行程序时，“等待1秒”，也可理解为“睡眠1秒”，适用于某些情况下需要人为让程序延迟的时候。',
  },
]

// 运算
let Operators = [
  {
    rightnavs: '运算',
    id: 'math_number',
    title: ' 一个数值',
    content: '一个数值，可以输入任意数值。',
    blockText: `<block type="math_number">
          <field name="NUM">123</field>
        </block>`,
  },
  {
    id: 'math_arithmetic_add',
    title: '数字运算',
    blockText: `<block type="math_arithmetic_add">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>`,
    content: '四则运算，对数字进行加减乘除处理，加法还可以把字符串、列表相加。',
  },
  {
    id: 'logic_compare_1',
    title: '比较式',
    blockText: `<block type="logic_compare_1">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '比较表达式为布尔表达式，如果条件成立，则返回True，条件不成立则返回False。',
  },
  {
    id: 'logic_operation',
    title: '逻辑运算',
    blockText: `<block type="logic_operation">
          <value name="A">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="logic_null">
              <field></field>
            </shadow>
          </value>
        </block>`,
    content:
      ' “并且”两边的条件同时成立，这个布尔表达式才算成立。\n“或”两边只要有一边条件成立，这个布尔值表达式就算成立。',
  },
  {
    id: 'logic_boolean',
    title: '逻辑运算：“非”',
    blockText: `<block type="logic_boolean"></block>`,
    content: '对当前的布尔表达式取反，如果当前表达式成立，则返回的值为不成立。',
  },
  {
    id: 'math_random_int',
    title: '随机整数',
    blockText: `<block type="math_random_int">
          <value name="FROM">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="TO">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>`,
    content:
      '1到10中随机取一个整数，区间[1,10]，前闭后闭，1和10两个值都有可能随机取到。',
  },
  {
    id: 'math_modulo',
    title: '除法求余数',
    blockText: `<block type="math_modulo">
          <value name="DIVIDEND">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="DIVISOR">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '余数指整数除法中被除数未被除尽部分，且余数的取值范围为0到除数之间（不包括除数）的整数。例如：64除以10，商数为6，余数为4。',
  },
  {
    id: 'math_single',
    title: '绝对值',
    blockText: `<block type="math_single">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content:
      '绝对值是指一个数在数轴上所对应点到原点的距离，用“| |”来表示。\n正数和0的绝对值为它本身。\n负数的绝对值是它的相反数。',
  },
  {
    id: 'math_trig',
    title: '正弦值',
    blockText: `<block type="math_trig">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">45</field>
            </shadow>
          </value>
        </block>`,
    content: '返回指定角度的正弦值（非弧度）。',
  },
  {
    id: 'math_constant',
    title: '常见值',
    blockText: `<block type="math_constant"></block>`,
    content:
      ' 返回一个常见量：π（3.141…）、e（2.718…）、φ（1.618…）、平方根（1.414…）、开平方根（0.707…）或∞无限大”。',
  },
  {
    id: 'math_number_property',
    title: '检查数值属性',
    blockText: `<block type="math_number_property">
          <value name="NUMBER_TO_CHECK">
            <shadow type="math_number">
              <field name="NUM">0</field>
            </shadow>
          </value>
        </block>`,
    content:
      ' 检查一个数值是否是偶数、奇数、质数、自然数、正数、负数或者是否能被某数整除。返回真或假。',
  },
  {
    id: 'math_round',
    title: '四舍五入',
    blockText: `<block type="math_round">
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">3.1</field>
            </shadow>
          </value>
        </block>`,
    content: '数值小数点后数字向上或向下舍入。',
  },
  {
    id: 'math_random_float',
    title: '随机小数',
    blockText: `<block type="math_random_float"></block>`,
    content: '返回一个介于0.0到1.0之间（含边界）的随机数。',
  },
  {
    id: 'math_on_list',
    title: '列表中数值的和',
    blockText: `<block type="math_on_list">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '返回列表中的所有数值的和。',
  },
  {
    id: 'math_constrain',
    title: '将数值限制在指定数值范围',
    blockText: `<block type="math_constrain">
          <value name="VALUE">
            <shadow type="math_number">
              <field name="NUM">50</field>
            </shadow>
          </value>
          <value name="LOW">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="HIGH">
            <shadow type="math_number">
              <field name="NUM">100</field>
            </shadow>
          </value>
        </block>`,
    content: '将一个数值限制在两个指定的数值范围（含边界）之间。',
  },
  {
    id: 'math_atan2',
    title: '反正切值',
    blockText: `<block type="math_atan2">
          <value name="X">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="Y">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>`,
    content: '返回点（X,Y）的反正切值，范围为-180度到180度。',
  },
]

// 字符串
let Text = [
  {
    rightnavs: '字符串',
    id: 'text',
    title: ' 字符串',
    content: '新建一个字符串。',
    blockText: `<block type="text"></block>`,
  },
  {
    id: 'text_join',
    title: '建立文本从__',
    blockText: `<block type="text_join"></block>`,
    content: '通过串起任意数量的项以建立一段文本。',
  },
  {
    id: 'text_length',
    title: '文本的长度',
    blockText: `<block type="text_length">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>`,
    content: '返回给定文本的字母数（包括空格）。',
  },
  {
    id: 'gta_ai_variable_change',
    title: '将数字转化为整数',
    blockText: `<block type="gta_ai_variable_change"></block>`,
    content:
      '将文本对象转化为整数类。若输入的不是整数，系统将会报错。“并且”两边的条件同时成立，这个布尔表达式才算成立。',
  },
  {
    id: 'gta_ai_variable_change_2',
    title: '将数字转化为整数',
    blockText: `<block type="gta_ai_variable_change_2">
    <value name="NAME">
      <shadow type="text">
        <field name="TEXT"></field>
      </shadow>
    </value>
  </block>`,
    content:
      '将文本对象转化为整数类。若输入的不是整数，系统将会报错。“并且”两边的条件同时成立，这个布尔表达式才算成立。',
  },
  {
    id: 'text_changeCase',
    title: '文字大小写模式',
    blockText: `<block type="text_changeCase">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>`,
    content: '用不同的大小写模式复制并返回这段文字。',
  },
  {
    id: 'gta_ai_text_include',
    title: '判断一串字符中是否包含特定字符',
    blockText: `<block type="gta_ai_text_include"></block>`,
    content: '判断前一个空格中的字符是否存在于后面的字符串中。',
  },
  {
    id: 'gta_ai_text_include_2',
    title: '判断一串字符中是否包含特定字符',
    blockText: `<block type="gta_ai_text_include_2">
    <value name="NAME">
      <shadow type="text">
        <field name="TEXT">Hello</field>
      </shadow>
    </value>
    <value name="NAME2">
      <shadow type="text">
        <field name="TEXT">Hello</field>
      </shadow>
    </value>
  </block>`,
    content: '判断前一个空格中的字符是否存在于后面的字符串中。',
  },
  {
    id: 'text_isEmpty',
    title: '判断文本是否为空',
    blockText: `<block type="text_isEmpty">
          <value name="VALUE">
            <shadow type="text">
              <field name="TEXT"></field>
            </shadow>
          </value>
        </block>`,
    content: '如果给定的文本为空，则返回真。',
  },
  {
    id: 'text_indexOf',
    title: '文本中寻找第一次/最后一次出现的字符',
    blockText: `<block type="text_indexOf">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">文本</field>
            </block>
          </value>
          <value name="FIND">
            <shadow type="text">
              <field name="TEXT">abcd</field>
            </shadow>
          </value>
        </block>`,
    content: '寻找文本中第一次/最后一次出现特定的字符串的位置。',
  },
  {
    id: 'lists_split',
    title: '从文本制作列表',
    blockText: `<block type="lists_split">
          <value name="INPUT">
            <block type="variables_get">
              <field name="VAR">文本</field>
            </block>
          </value>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>`,
    content: '将文本分割为列表。',
  },
  {
    id: 'lists_split_1',
    title: '从列表拆出文本',
    blockText: `<block type="lists_split_1">
          <value name="INPUT">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
          <value name="DELIM">
            <shadow type="text">
              <field name="TEXT">,</field>
            </shadow>
          </value>
        </block>`,
    content: '将列表分拼接为文本。',
  },
  {
    id: 'text_getSubstring',
    title: '取得子字符',
    blockText: `<block type="text_getSubstring">
          <value name="STRING">
            <block type="variables_get">
              <field name="VAR">文本</field>
            </block>
          </value>
          <value name="AT1">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
          <value name="AT2">
            <shadow type="math_number">
              <field name="NUM"></field>
            </shadow>
          </value>
        </block>`,
    content: '获取文本的子字符。',
  },
  {
    id: 'text_append',
    title: '附加文本',
    blockText: `<block type="text_append">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>`,
    content: '在文本后面添加文本进去。',
  },
  {
    id: 'text_trim',
    title: '消除其两侧的空白',
    blockText: `<block type="text_trim">
          <value name="TEXT">
            <shadow type="text">
              <field name="TEXT">abc</field>
            </shadow>
          </value>
        </block>`,
    content: '删除文本两侧的空白符。',
  },
]

// 列表
let List = [
  {
    rightnavs: '列表',
    id: 'lists_create_with',
    title: ' 创建空列表',
    content: '新建一个列表类型数据',
    blockText: `<block type="lists_create_with">
          <mutation items="0"></mutation>
        </block>`,
  },
  {
    id: 'lists_establish_with',
    title: '建立列表从__',
    blockText: `<block type="lists_establish_with">
          <mutation items="2"></mutation>
        </block>`,
    content: '通过串起任意数量的项以建立一个列表',
  },
  {
    id: 'lists_setIndex',
    title: '在列表中设置',
    blockText: `<block type="lists_setIndex">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '设置列表某个索引的值',
  },
  {
    id: 'lists_getIndex',
    title: '在列表中取得',
    blockText: `<block type="lists_getIndex">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '获取列表某个索引的值',
  },
  {
    id: 'lists_indexOf',
    title: '在列表中寻找第一次出现的项',
    blockText: `<block type="lists_indexOf">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '获取列表某个数据第一次出现的索引。',
  },
  {
    id: 'lists_length',
    title: '列表的长度',
    blockText: `<block type="lists_length">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '获取列表的长度。',
  },
  {
    id: 'lists_getSublist',
    title: '在列表中获取子列表从#',
    blockText: `<block type="lists_getSublist">
          <value name="LIST">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '获取子列表',
  },
  {
    id: 'lists_isEmpty',
    title: '列表是空的',
    blockText: `<block type="lists_isEmpty">
          <value name="VALUE">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '判断是否空列表。',
  },
  {
    id: 'lists_repeat',
    title: '建立列表使用项',
    blockText: `<block type="lists_repeat">
          <value name="ITEM">
            <block type="text"></block>
          </value>
          <value name="NUM">
            <shadow type="math_number">
              <field name="NUM">5</field>
            </shadow>
          </value>
        </block>`,
    content: '建立列表使用项',
  },
  {
    id: 'gta_ai_lists_include',
    title: '存在于列表',
    blockText: `<block type="gta_ai_lists_include">
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">列表</field>
            </block>
          </value>
        </block>`,
    content: '存在于列表',
  },
  {
    id: 'gta_ai_lists_include_2',
    title: '存在于列表',
    blockText: `<block type="gta_ai_lists_include_2">
    <value name="NAME">
      <shadow type="text">
        <field name="TEXT"></field>
      </shadow>
    </value>
    <value name="NAME2">
      <block type="variables_get">
        <field name="VAR">{listVariable}</field>
      </block>
    </value>
  </block>`,
    content: '存在于列表',
  },
  {
    id: 'lists_sort',
    title: '列表排序',
    blockText: `<block type="lists_sort"></block>`,
    content: '列表排序。',
  },
]

// 字典
let Dictionary = [
  {
    rightnavs: '字典',
    id: 'create_dict',
    title: '设置一个键和值',
    content: '分别设置字典的键和值，作为创建字典的键值对属性',
    blockText: `<block type="create_dict"></block>`,
  },
  {
    id: 'dict_create_with',
    title: '创建字典',
    blockText: `<block type="dict_create_with">
          <mutation items="1"></mutation>
        </block>`,
    content: '建立一个字典DT类型的数据，字典属性为键值对映射格式',
  },
  {
    id: 'set_dict',
    title: '设置键与值',
    blockText: `<block type="set_dict"></block>`,
    content: '通过键“nb”查找到对应的值，并且返回值。',
  },
  {
    id: 'gta_ai_get_dict_key',
    title: '读取键名对应的值',
    blockText: `<block type="gta_ai_get_dict_key"></block>`,
    content: '读取某个键的值',
  },
  {
    id: 'length_of_dict',
    title: '键总数',
    blockText: `<block type="length_of_dict"></block>`,
    content: '获取字典DT中键的总数，返回一个整数型数字。',
  },
  {
    id: 'del_dict_key',
    title: '删除字典',
    blockText: `<block type="del_dict_key"></block>`,
    content: ' 删除字典DT的键“nb”以及”nb”对应的值。',
  },
  {
    id: 'del_dict_key_2',
    title: '删除字典',
    blockText: `      <block type="del_dict_key_2">
    <value name="key">
     <block type="text">
       <field name="TEXT"></field>
     </block>
   </value>
 </block>`,
    content: ' 删除字典DT的键“nb”以及”nb”对应的值。',
  },
  {
    id: 'gta_ai_dict_include',
    title: '键是否存在',
    blockText: `<block type="gta_ai_dict_include">
          <value name="NAME2">
            <block type="variables_get">
              <field name="VAR">DT</field>
            </block>
          </value>
        </block>`,
    content: '通过键“nb”查找到对应的值，并且返回值。',
  },
  {
    id: 'gta_ai_dict_include_2',
    title: '键是否存在',
    blockText: `<block type="gta_ai_dict_include_2">
    <value name="NAME">
      <shadow type="text">
        <field name="TEXT"></field>
      </shadow>
    </value>
    <value name="NAME2">
      <block type="variables_get">
        <field name="VAR">DT</field>
      </block>
    </value>
  </block>`,
    content: '通过键“nb”查找到对应的值，并且返回值。',
  },
]

// 变量
let Variable = [
  {
    rightnavs: '变量',
    id: 'variables_set',
    title: '赋值变量',
    blockText: `<block type="variables_set"></block>`,
    content: `AA=0这句赋值语句，不仅给变量赋值了数字0，同时还定义了变量当前的数据类型是数字。数字类型的变量不能直接使用字符串、列表、字典等其他数据类型的数据规则进行改变，否则会报错。

    但是在Python中变量的数据类型是动态的，重新定义便可以改变变量的数据类型，这也是Python语言的一大特点。

    实际上，在代码模式下，AA=0这句短短的代码，同时完成了创建变量、定义变量的数据类型、给变量赋值三项任务。

    提醒：所有的变量都必须有初始赋值的过程，否则直接调用变量会报错哦~`,
  },
  {
    id: 'math_change',
    title: '变量增加',
    content: `变量增加值。`,
    blockText: `<block type="math_change"></block>`,
  },
  {
    id: 'variables_get',
    title: '获取变量',
    blockText: `<block type="variables_get"> </block>`,
    content: `AA=0这句赋值语句，不仅给变量赋值了数字0，同时还定义了变量当前的数据类型是数字。数字类型的变量不能直接使用字符串、列表、字典等其他数据类型的数据规则进行改变，否则会报错。

    但是在Python中变量的数据类型是动态的，重新定义便可以改变变量的数据类型，这也是Python语言的一大特点。

    实际上，在代码模式下，AA=0这句短短的代码，同时完成了创建变量、定义变量的数据类型、给变量赋值三项任务。

    提醒：所有的变量都必须有初始赋值的过程，否则直接调用变量会报错哦~`,
  },
]

// 函数
let Function = [
  {
    rightnavs: '函数',
    id: 'procedures_defnoreturn',
    title: '定义无返回函数',
    content: `含义：
    1. 定义函数时，需要先定义函数的名称，点击上图中字母function所在的区域，就可以编 辑函数名。
    函数名需要满足以下几条规则：
    函数名可以同时包含字母和数字，但不能以数字开头。
    函数名中的字符必须是字母、数字、下划线或者汉字，不能使用其他字符。
    函数名区分大小写。
    函数不可以与关键词同名，同时为了防止一些理解上的误会，在积木模式下数名 不可以与任何Python其他内置函数同名。
    2. 要使用函数，光对函数进行定义可不行哦！函数定义只是构造了这个函数，要使函数真 正发挥作用，还要对函数进行调用，后面的部分会详细讲到如何调用函数。`,
    blockText: `<block type="procedures_defnoreturn"></block>`,
  },
  // {
  //   id: 'procedures_mutatorcontainer',
  //   title: '定义有返回函数',
  //   blockText: `<block type="procedures_mutatorcontainer"></block>`,
  //   content: '函数定义后，要调用它，函数才能发挥它的效果哦。',
  // },
  {
    id: 'procedures_defreturn',
    title: '输出值函数',
    blockText: `<block type="procedures_defreturn"></block>`,
    content: `含义：
    1. 创建一个有输出值的函数。
    2. 要将一个函数结束运行时得出的信息传递给程序的剩余部分，可以使用带“返回”的函数。
    3. 当运行到“返回”时，函数会停止运行，并返回对应表达式的值。
      有返回值的函数是椭圆型的哦，可以塞到其他的积木中，返回值能够被运行。`,
  },
  {
    id: 'procedures_ifreturn',
    title: '如果…..返回…..',
    blockText: `<block type="procedures_ifreturn"></block>`,
    content:
      '如果里面的值判断为真，则返回相关数值。提示：这个块只能在函数内部使用。',
  },
]

// 媒体
let Media = [
  {
    rightnavs: '媒体',
    id: 'play_audio',
    title: '播放音频',
    content: '开始播放音频。',
    blockText: `<block type="play_audio"></block>`,
  },
  {
    id: 'pause_audio',
    title: '停止播放音频',
    blockText: `<block type="pause_audio"> </block>`,
    content: '停止播放音频。',
  },
  {
    id: 'volume_add_audio',
    title: '音量增加',
    blockText: `<block type="volume_add_audio"></block>`,
    content:
      '用于对音量的大小进行控制，可以为负数或正整数，负数为减小音量，正数为增加音量。',
  },
  {
    id: 'volume_set_audio',
    title: '音量设置',
    blockText: `<block type="volume_set_audio"></block>`,
    content: '将音量设定到固定值。',
  },
]

export default {
  Inits,
  Events,
  Control,
  Operators,
  Text,
  List,
  Dictionary,
  Variable,
  Function,
  Media,
}
